import React from "react";
import Select from "react-select";

import _ from "lodash";

import { beautifyBuiltinPropName } from "../../util";
import { builtinPropNames } from "../sendBuiltinExamples";

const sendBuiltinPropNameOptions = builtinPropNames.map((name) => ({
  value: name,
  label: beautifyBuiltinPropName(name),
}));

const sendBuiltinPropNameOptionsMap = _(sendBuiltinPropNameOptions)
  .keyBy("value")
  .value();

function SendBuiltinPropertyInputs({
  originalBuiltinPropName,
  setOriginalBuiltinPropName,
  newPropName,
  setNewPropName,
}) {
  return (
    <>
      <Select
        className="mt-2"
        placeholder="Builtin Property Name..."
        options={sendBuiltinPropNameOptions}
        value={sendBuiltinPropNameOptionsMap[originalBuiltinPropName]}
        onChange={(e) => setOriginalBuiltinPropName(e.value)}
      />
      <input
        className="py-2 px-2 w-full mt-2 font-mono border rounded tracking-tight"
        placeholder="Send As..."
        value={newPropName}
        onChange={(e) => setNewPropName(e.target.value)}
      />
    </>
  );
}

export { SendBuiltinPropertyInputs };
